export async function asyncMap(array = [], callback = async () => {}) {
    const ret = []
    for (let i = 0; i < array.length; i++) {
        ret.push(await callback(array[i], i, array))
    }
    return ret
}
